import styled from 'styled-components';

const TH = styled.td`
  padding: 0.75rem;
  border: 1px solid #e9ecef;
  vertical-align: bottom;
  font-weight: 600;
  background-color:  ${(props) => (props.backgroundColor) ? props.backgroundColor : '#b4b4b4'};
  color: ${(props) => (props.color) ? props.color : '#000'};
`;

export default TH;



// WEBPACK FOOTER //
// ./app/components/Table/TH.js